var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H3L4 15H6L7 17H12V5H1V17Z",
    fill: "#C3B9D2",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19Z",
    stroke: "#C3B9D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C19.1046 19 20 18.1046 20 17C20 15.8954 19.1046 15 18 15C16.8954 15 16 15.8954 16 17C16 18.1046 16.8954 19 18 19Z",
    stroke: "#C3B9D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H16",
    stroke: "#C3B9D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17H2C1.44772 17 1 16.5523 1 16V6C1 5.44772 1.44772 5 2 5H12.0775C13.2926 5 14.4419 5.55236 15.201 6.50122L17.3995 9.24939C17.7791 9.72382 18.3612 10 18.9688 10V10C21.1779 10 23 11.7909 23 14V16C23 16.5523 22.5523 17 22 17H20",
    stroke: "#C3B9D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17V5",
    stroke: "#C3B9D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H12",
    stroke: "#C3B9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.6189785bb4fddb8cbce117aa52317c3b.svg";
export { ForwardRef as ReactComponent };